import { __assign, __extends } from "tslib";
import React, { Component } from "react";
import { connect } from "react-redux";
import { PnmacChatAvatar, PnmacLinearProgress, PnmacMediaQuery, PnmacMeta, PnmacModal, PnmacPageBubble, PnmacRowHeader, PnmacSectionListView, PnmacText, PnmacToolTip, PnmacUIButton, HtmlToNativeNative, FileUpload } from "pnmac-universal-components";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import styles from "../../styles/styles.js";
import moment from "moment";
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../../redux/events/events.js";
import { Image, Linking, Platform, Text, View } from "react-native";
import { textStyle } from '../../v2/theme';
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import ExpanderComponent from "./ExpanderComponent";
import PendingTable from "./PendingTable";
import CompletedTable from "./CompletedTable";
import BannerView from '../../v2/BannerView';
import { PnmacParagraph } from '../../Typography';
var AntDesign = function () {
  return /*#__PURE__*/React.createElement(View, null);
};
if (Platform.OS !== "web") {
  try {
    AntDesign = require("react-native-vector-icons/AntDesign").default;
  } catch (error) {}
}
function TransitionsModal(_a) {
  var open = _a.open,
    closeModal = _a.closeModal,
    translations = _a.translations,
    children = _a.children;
  var classes = {};
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacModal, {
    "aria-labelledby": "transition-modal-title",
    "aria-describedby": "transition-modal-description",
    className: classes.modal,
    open: open,
    closeAfterTransition: true
  }, /*#__PURE__*/React.createElement(View, {
    className: classes.paper,
    style: {
      backgroundColor: "#fff",
      padding: 20,
      borderRadius: 10
    }
  }, children, /*#__PURE__*/React.createElement(View, {
    style: {
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(PnmacUIButton, {
    idTag1: 'btnModalPopupOK',
    style: {
      width: '40%',
      marginTop: 20
    },
    mode: "contained",
    onPress: function () {
      return closeModal();
    }
  }, translations.ModalPopupOkButtonText)))));
}
var Index = /** @class */function (_super) {
  __extends(Index, _super);
  function Index(props) {
    var _this = _super.call(this, props) || this;
    _this.uploadForm = function (data) {
      var _a, _b;
      var fileTypes = ".pdf, .doc, .docx, .png, .jpg, .tif, .txt.pdf, .doc, .docx, .png, .jpg, .tif, .txt";
      var fileTypesList = fileTypes.split(", ");
      var validFileType = false;
      var validFileSize = true;
      var fileNotRecognized = false;
      var fileSize = data.selectedFile.size;
      var maxfileSize = 20971520;
      var selectedFileName = data.selectedFile.name;
      if (data.selectedFile == undefined || data.selectedFile == null) {
        fileNotRecognized = true;
      }
      for (var i = 0; i < fileTypesList.length; i++) {
        if (data.selectedFile.name.indexOf(fileTypesList[i]) > 0) {
          validFileType = true;
          break;
        }
      }
      if (fileSize > maxfileSize) {
        validFileSize = false;
      }
      if (fileNotRecognized || !validFileType || !validFileSize) {
        var selectedLoanNumber = ((_a = _this.props) === null || _a === void 0 ? void 0 : _a.layout).selectedLoanNumber;
        _this.props.refreshSingleLoanData(selectedLoanNumber).then(function () {
          return _this.setState({
            loading: false,
            open: true,
            selectedFile: selectedFileName,
            isFileNotRecognized: fileNotRecognized,
            isValidFileType: validFileType,
            isValidFileSize: validFileSize
          });
        });
      }
      if (!fileNotRecognized && validFileType && validFileSize) {
        var _c = (_b = _this.props) === null || _b === void 0 ? void 0 : _b.layout,
          selectedLoanNumber_1 = _c.selectedLoanNumber,
          modifications = _c.modifications,
          pennyHomeUrl = _c.pennyHomeUrl;
        var form = new FormData();
        form.append("file", data.selectedFile);
        form.append("loanId", selectedLoanNumber_1);
        form.append("modificationId", modifications.modificationId);
        form.append("conditionId", data.conditionId);
        console.log(form);
        fetch(pennyHomeUrl + "api/modification/upload_mod_doc", {
          method: "POST",
          headers: {
            "Authorization": "Bearer ".concat(_this.props.layout.token)
          },
          body: form
        }).then(function (s) {
          if (s.ok) {
            _this.props.refreshSingleLoanData(selectedLoanNumber_1, function () {
              return _this.setState({
                loading: false,
                open: true,
                selectedFile: selectedFileName,
                isFileNotRecognized: fileNotRecognized,
                isValidFileType: validFileType,
                isValidFileSize: validFileSize
              });
            });
          }
        });
        _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Mod Docs Uploads", 210015);
      }
    };
    _this.expRef = /*#__PURE__*/React.createRef();
    _this.expRefList = /*#__PURE__*/React.createRef();
    _this.fileref = /*#__PURE__*/React.createRef();
    _this.state = {
      alert: false,
      conditionId: 0,
      loading: false,
      open: false,
      fileName: null,
      selectedFile: null,
      isFileNotRecognized: false,
      isValidFileType: false,
      isValidFileSize: false
    };
    return _this;
  }
  Index.prototype.componentDidMount = function () {
    var _a, _b;
    var translations = this.props.translations;
    var d = (_b = (_a = this.expRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.collapseItem(translations.NextSteps);
  };
  Index.prototype.componentDidUpdate = function () {
    var _a, _b;
    var translations = this.props.translations;
    var d = (_b = (_a = this.expRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.collapseItem(translations.NextSteps);
  };
  Index.prototype.render = function () {
    var _this = this;
    var _a, _b;
    var _c = this,
      props = _c.props,
      state = _c.state;
    var translations = props.translations,
      layout = props.layout,
      pnmacTheme = props.pnmacTheme;
    var _d = this.props.layout,
      selectedLoanNumber = _d.selectedLoanNumber,
      currentLoan = _d.currentLoan;
    var _e = this.props.layout,
      modifications = _e.modifications,
      modLoaded = _e.modLoaded;
    var alert = state.alert,
      loading = state.loading;
    if (modifications == null || !((modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeIsApplication) || (modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeIsUnderReview) || (modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeIsDecision) || (modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeIsInTrial) || (modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeIsPendingDocuments) || (modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeIsCompleted))) {
      return /*#__PURE__*/React.createElement(View, {
        id: "main-content",
        className: "container -5 pb-5 pt-4"
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.ModificationStatus
      }), /*#__PURE__*/React.createElement(PnmacPageBubble, {
        idTag1: "modAssistanceStatus",
        accessibilityRole: "header",
        ariaLevel: "1",
        containerStyles: {
          marginLeft: 10,
          marginBottom: 0
        },
        text: translations.ModificationStatus
      }), modLoaded === false ? (/*#__PURE__*/React.createElement(View, {
        style: {
          marginHorizontal: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacLinearProgress, null))) : (/*#__PURE__*/React.createElement(Text, {
        style: [{
          marginHorizontal: 10
        }, textStyle.defaultTextDescription]
      }, translations.FeatureUnavailable)));
    } else if (modifications === null || modifications === void 0 ? void 0 : modifications.hasUpcomingForeclosureSale) {
      return /*#__PURE__*/React.createElement(View, {
        id: "main-content",
        className: "container -5 pb-5 pt-4"
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.ModificationStatus
      }), /*#__PURE__*/React.createElement(PnmacPageBubble, {
        idTag1: "modAssistanceStatus",
        accessibilityRole: "header",
        ariaLevel: "1",
        containerStyles: {
          marginLeft: 10,
          marginBottom: 0
        },
        text: translations.ModificationStatus
      }), /*#__PURE__*/React.createElement(View, {
        style: {
          marginHorizontal: 10
        }
      }, /*#__PURE__*/React.createElement(Text, {
        style: textStyle.defaultTextDescription
      }, translations.ContactUs), /*#__PURE__*/React.createElement(Text, {
        style: textStyle.defaultTextDescription
      }, translations.ForeClosureTxt1, /*#__PURE__*/React.createElement(Text, {
        style: textStyle.defaultTextTitle
      }, modifications === null || modifications === void 0 ? void 0 : modifications.spoc), translations.ForeClosureTxt2, /*#__PURE__*/React.createElement(Text, {
        style: textStyle.clickableLink,
        onPress: function () {
          return Linking.openURL("tel:118666294570");
        }
      }, ' (866) 629-4570 '), translations.ForeClosureTxt3)));
    } else if (modifications === null || modifications === void 0 ? void 0 : modifications.sixtyDaysPastDecision) {
      return /*#__PURE__*/React.createElement(View, {
        id: "main-content",
        className: "container -5 pb-5 pt-4"
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.ModificationStatus
      }), /*#__PURE__*/React.createElement(PnmacPageBubble, {
        idTag1: "modAssistanceStatus",
        accessibilityRole: "header",
        ariaLevel: "1",
        containerStyles: {
          marginLeft: 10,
          marginBottom: 0
        },
        text: translations.ModificationStatus
      }), /*#__PURE__*/React.createElement(View, {
        style: {
          marginHorizontal: 10
        }
      }, /*#__PURE__*/React.createElement(Text, {
        style: textStyle.defaultTextDescription
      }, translations.ContactUs), /*#__PURE__*/React.createElement(Text, {
        style: textStyle.defaultTextDescription
      }, (_a = layout === null || layout === void 0 ? void 0 : layout.translations) === null || _a === void 0 ? void 0 : _a.NoLongerAvail, translations.ClosedTxt1, /*#__PURE__*/React.createElement(Text, {
        style: textStyle.defaultTextTitle
      }, modifications === null || modifications === void 0 ? void 0 : modifications.spoc), translations.ForeClosureTxt2, /*#__PURE__*/React.createElement(Text, {
        style: textStyle.clickableLink,
        onPress: function () {
          return Linking.openURL("tel:118666294570");
        }
      }, ' (866) 629-4570 '), translations.ForeClosureTxt3)));
    } else {
      var YourNextStepModStatusDescription_1 = null;
      var OurNextStepModStatusDescription_1 = null;
      var modstatustype = (_b = modifications === null || modifications === void 0 ? void 0 : modifications.statusType) === null || _b === void 0 ? void 0 : _b.lookupName;
      if (modstatustype != null && modstatustype != undefined) {
        switch (modstatustype) {
          case "Welcome package to be sent":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsApplicationWelcomepackagetobesent;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsApplicationWelcomepackagetobesent;
            break;
          case "Welcome package to be received":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsApplicationWelcomepackagetobereceived;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsApplicationWelcomepackagetobereceived;
            break;
          case "30 day notice sent":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsApplication30daynoticesent;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsApplication30daynoticesent;
            break;
          case "15 day notice sent":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsApplication15daynoticesent;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsApplication15daynoticesent;
            break;
          case "Package Received / File Prep":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsApplicationPackageReceivedOrFilePrep;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsApplicationPackageReceivedOrFilePrep;
            break;
          case "Awaiting decision - incomplete package":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsApplicationAwaitingDecisionIncompletepackage;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsApplicationAwaitingDecisionIncompletepackage;
            break;
          case "Awaiting assignment":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsUnderReviewAwaitingAssignment;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsUnderReviewAwaitingAssignment;
            break;
          case "Pending review":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsUnderReviewPendingReview;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsUnderReviewPendingReview;
            break;
          case "In Review":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsUnderReviewInReview;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsUnderReviewInReview;
            break;
          case "2nd Look Review":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsUnderReview2ndLookReview;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsUnderReview2ndLookReview;
            break;
          case "Awaiting decision":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionAwaitingDecision;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionAwaitingDecision;
            break;
          case "Approved - send trial package":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionApprovedsendtrialpackage;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionApprovedsendtrialpackage;
            break;
          case "Declined":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionDeclined;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionDeclined;
            break;
          case "Awaiting investor decision":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionAwaitingInvestorDecision;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionAwaitingInvestorDecision;
            break;
          case "FHA Triage":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionFHATriage;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionFHATriage;
            break;
          case "VA Triage":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionVATriage;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionVATriage;
            break;
          case "USDA Triage":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionUSDATriage;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionUSDATriage;
            break;
          case "Mod review complete - file to QA":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionModReviewcompleteFiletoQA;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionModReviewcompleteFiletoQA;
            break;
          case "QA Updates - Underwriting":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionQAUpdatesUnderwriting;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionQAUpdatesUnderwriting;
            break;
          case "2nd Sign Requested":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecision2ndSignRequested;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecision2ndSignRequested;
            break;
          case "2nd Sign Updates":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecision2ndSignUpdates;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecision2ndSignUpdates;
            break;
          case "File to Docs":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionFileToDocs;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionFileToDocs;
            break;
          case "QA Updates - Processing":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionQAUpdatesProcessing;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionQAUpdatesProcessing;
            break;
          case "2nd Sign Completed":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecision2ndSignCompleted;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecision2ndSignCompleted;
            break;
          case "Triage":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionTriage;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionTriage;
            break;
          case "QA Review Completed":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionQAReviewCompleted;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionQAReviewCompleted;
            break;
          case "Disaster Triage":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionDisasterTriage;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionDisasterTriage;
            break;
          case "Streamline Import Trial":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionStreamlineImportTrial;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionStreamlineImportTrial;
            break;
          case "Streamline Import Final":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionStreamlineImportFinal;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionStreamlineImportFinal;
            break;
          case "Upfront Streamline":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionUpfrontStreamline;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionUpfrontStreamline;
            break;
          case "Disaster Review":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionDisasterReview;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionDisasterReview;
            break;
          case "File Back to QA":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionFileBacktoQA;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionFileBacktoQA;
            break;
          case "Internal QA":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionInternalQA;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionInternalQA;
            break;
          case "Internal QA - Finding":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionInternalQAFinding;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionInternalQAFinding;
            break;
          case "File Back to Internal QA - Agree":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionFileBacktoInternalQAAgree;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionFileBacktoInternalQAAgree;
            break;
          case "File Back to Internal QA - Disagree":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionFileBacktoInternalQADisagree;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionFileBacktoInternalQADisagree;
            break;
          case "Internal QA Complete":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionInternalQAComplete;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionInternalQAComplete;
            break;
          case "Approved - Ready for Release":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionApprovedReadyForRelease;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionApprovedReadyForRelease;
            break;
          case "Final Docs - File to QA":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionFinalDocsFiletoQA;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionFinalDocsFiletoQA;
            break;
          case "Doc Release - QA Finding":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionDocReleaseQAFinding;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionDocReleaseQAFinding;
            break;
          case "Doc Release - QA Finding - Agree":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionDocReleaseQAFindingAgree;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionDocReleaseQAFindingAgree;
            break;
          case "Doc Release - QA Finding - Disagree":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionDocReleaseQAFindingDisagree;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionDocReleaseQAFindingDisagree;
            break;
          case "Doc Release - QA Finding - Agree 3rd Party":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionDocReleaseQAFindingAgree3rdParty;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionDocReleaseQAFindingAgree3rdParty;
            break;
          case "Doc Release - QA Finding UW":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionDocReleaseQAFindingUW;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionDocReleaseQAFindingUW;
            break;
          case "Ready to Mail":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecisionReadytoMail;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecisionReadytoMail;
            break;
          case "2nd Sign":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsDecision2ndSign;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsDecision2ndSign;
            break;
          case "Trial to be Accepted":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsTrialTrialtobeaccepted;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsTrialTrialtobeaccepted;
            break;
          case "Trial Payment Tracking":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsTrialTrialPaymentTracking;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsTrialTrialPaymentTracking;
            break;
          case "Ready to Draw - Final Docs":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsTrialReadytoDrawFinalDocs;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsTrialReadytoDrawFinalDocs;
            break;
          case "Final Documents to be received":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsFinalDocumentstobereceived;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsFinalDocumentstobereceived;
            break;
          case "Completed":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsCompleted;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsCompleted;
            break;
          case "Final Documents Received - In Review":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsFinalDocumentsreceivedInReview;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsFinalDocumentsreceivedInReview;
            break;
          case "Approved Send Final Docs / File Prep":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsApprovedsendfinaldocsORFilePrep;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsApprovedsendfinaldocsORFilePrep;
            break;
          case "Final Docs Received - BK Approval Pending":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsFinalDocsReceivedBKApprovalPending;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsFinalDocsReceivedBKApprovalPending;
            break;
          case "Final Docs Received - Pending Corrections":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsFinalDocsReceivedPendingConditions;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsFinalDocsReceivedPendingConditions;
            break;
          case "Final payment - Final Doc Prep":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsFinalpaymentFinaldocprep;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsFinalpaymentFinaldocprep;
            break;
          case "Final Payment / Final Docs to be received":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsFinalpaymentORFinaldocstobereceived;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsFinalpaymentORFinaldocstobereceived;
            break;
          case "Final Docs Received - Pending Customer Corrections":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsFinalDocsReceivedPendingCustomerCorrections;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsFinalDocsReceivedPendingCustomerCorrections;
            break;
          case "Final Docs Received - Pending Payment":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsFinalDocsReceivedPendingPayment;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsFinalDocsReceivedPendingPayment;
            break;
          case "Partial Claim Docs Received - QA Completed":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsPartialClaimDocsReceivedQACompleted;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsPartialClaimDocsReceivedQACompleted;
            break;
          case "Deferment To Be Accepted":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsDefermenttobeAccepted;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsDefermenttobeAccepted;
            break;
          case "MFC Validation step 1":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsModCompleteMFCValidationstep1;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsModCompleteMFCValidationstep1;
            break;
          case "MFC Validation step 2":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsModCompleteMFCValidationstep2;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsModCompleteMFCValidationstep2;
            break;
          case "MFC Validation step 3":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsModCompleteMFCValidationstep3;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsModCompleteMFCValidationstep3;
            break;
          case "MFC Pending Mod Review":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsModCompleteMFCPendingModReview;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsModCompleteMFCPendingModReview;
            break;
          case "Returned to Normal Servicing":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsModCompleteReturnedToNormalServicing;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsModCompleteReturnedToNormalServicing;
            break;
          case "Final Doc Prep":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsFinalDocPrep;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsFinalDocPrep;
            break;
          case "Final Docs - Ready To Close":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsFinalDocsReadyToClose;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsFinalDocsReadyToClose;
            break;
          case "Trial Default Review":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsTrialTrialDefaultReview;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsTrialTrialDefaultReview;
            break;
          case "Final Documents - Redraw Pending":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsFinalDocumentsRedrawPending;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsFinalDocumentsRedrawPending;
            break;
          case "Completed - Mod Adjustment QC Required":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsCompletedModAdjustmentQCRequired;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsCompletedModAdjustmentQCRequired;
            break;
          case "Exception Completed":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsExceptionCompleted;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsExceptionCompleted;
            break;
          case "Exception Requested":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsExceptionRequested;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsExceptionRequested;
            break;
          case "Mod review declined - file to QA":
            YourNextStepModStatusDescription_1 = translations.YourNextStepsModReviewDeclinedFileToQA;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsModReviewDeclinedFileToQA;
            break;
          default:
            YourNextStepModStatusDescription_1 = translations.YourNextStepsApplicationWelcomepackagetobesent;
            OurNextStepModStatusDescription_1 = translations.OurNextStepsApplicationWelcomepackagetobesent;
        }
      }
      var DATAEXPANDABLE_1 = [{
        title: translations.NextSteps,
        data: [{
          header: translations.NextSteps
        }]
      }].filter(function (s) {
        return s;
      });
      var DATAEXPANDABLELIST_1 = [{
        title: translations.CompletedItems,
        data: [{
          header: translations.CompletedItems
        }]
      }].filter(function (s) {
        return s;
      });
      var completed = modifications === null || modifications === void 0 ? void 0 : modifications.completedConditions.find(function (c) {
        return c;
      });
      var tableCompleteContent = [];
      if (completed) {
        tableCompleteContent = [{
          title: "",
          view: /*#__PURE__*/React.createElement(View, null, Platform.OS === "web" ? /*#__PURE__*/React.createElement(CheckBoxIcon, null) : /*#__PURE__*/React.createElement(AntDesign, {
            name: "checksquare",
            color: "#000",
            size: 20
          }))
        }, {
          title: translations.ModDescription,
          view: /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
            id: "completedCondtionDescription",
            style: {
              width: "100%",
              alignItems: "flex-start"
            }
          }, !completed.detailedExplanation || completed.detailedExplanation == "" ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(HtmlToNativeNative, {
            value: completed.conditionDescription,
            navigation: props.navigation
          })) : /*#__PURE__*/React.createElement(Text, null, completed.DetailedExplanation), !!completed.note && /*#__PURE__*/React.createElement(HtmlToNativeNative, {
            value: completed.note,
            navigation: props.navigation
          }), /*#__PURE__*/React.createElement(ExpanderComponent, __assign({}, this.props, completed))))
        }, {
          title: translations.CompletionDate,
          view: /*#__PURE__*/React.createElement(Text, {
            id: "completeddate"
          }, !!completed.completedDate ? moment(completed.completedDate).format("MM/DD/YYYY") : translations.NotApplicable)
        }];
      }
      var GetModStatus_1 = function (_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var matches = _a.matches;
        console.log("matches", matches);
        if (modifications === null || modifications === void 0 ? void 0 : modifications.hasUpcomingForeclosureSale) {
          return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, null, translations.ContactUs), /*#__PURE__*/React.createElement(Text, null, translations.ForeClosureTxt1, modifications === null || modifications === void 0 ? void 0 : modifications.spoc, translations.ForeClosureTxt2, /*#__PURE__*/React.createElement(Text, {
            href: "tel:118666294570"
          }, "(866) 629-4570"), translations.ForeClosureTxt3));
        } else if (modifications === null || modifications === void 0 ? void 0 : modifications.sixtyDaysPastDecision) {
          return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, null, (_b = layout === null || layout === void 0 ? void 0 : layout.translations) === null || _b === void 0 ? void 0 : _b.NoLongerAvail), /*#__PURE__*/React.createElement(Text, null, (_c = layout === null || layout === void 0 ? void 0 : layout.translations) === null || _c === void 0 ? void 0 : _c.ClosedTxt1, modifications === null || modifications === void 0 ? void 0 : modifications.spoc, (_d = layout === null || layout === void 0 ? void 0 : layout.translations) === null || _d === void 0 ? void 0 : _d.ForeClosureTxt2, /*#__PURE__*/React.createElement(Text, {
            href: "tel:18666294570"
          }, "(866) 629-4570"), ".", (_e = layout === null || layout === void 0 ? void 0 : layout.translations) === null || _e === void 0 ? void 0 : _e.ClosedTxt2));
        }
        return /*#__PURE__*/React.createElement(View, {
          id: "main-content",
          className: "container -5 pb-5 pt-4"
        }, /*#__PURE__*/React.createElement(PnmacMeta, {
          title: translations.ModificationStatus
        }), /*#__PURE__*/React.createElement(PnmacPageBubble, {
          idTag1: "modAssistanceStatus",
          accessibilityRole: "header",
          ariaLevel: "1",
          containerStyles: {
            marginLeft: 10,
            marginBottom: 0
          },
          text: translations.ModificationStatus
        }), /*#__PURE__*/React.createElement(PnmacText, {
          style: {
            margin: 10,
            fontWeight: "700",
            color: "#000",
            fontSize: Platform.OS === "web" ? 22 : 18
          }
        }, translations.ModStatusHeader), /*#__PURE__*/React.createElement(View, {
          style: {
            flex: 1,
            flexDirection: matches.small ? "column" : "row",
            margin: 10
          }
        }, /*#__PURE__*/React.createElement(View, {
          style: {
            flexDirection: "column",
            marginVertical: 10
          }
        }, /*#__PURE__*/React.createElement(Text, {
          style: {
            flex: 1,
            fontWeight: "700",
            fontSize: Platform.OS === "web" ? 18 : 14
          }
        }, translations.LoanNumber), /*#__PURE__*/React.createElement(Text, {
          id: "selectedLoanNumber",
          style: {
            flex: 1
          }
        }, selectedLoanNumber), /*#__PURE__*/React.createElement(Text, {
          style: {
            flex: 2,
            fontWeight: "700",
            marginTop: 10,
            fontSize: Platform.OS === "web" ? 18 : 14
          }
        }, translations.NamePropertyAddress), /*#__PURE__*/React.createElement(Text, {
          id: "namepropertyAddress",
          style: {
            flex: 1
          }
        }, (_f = modifications === null || modifications === void 0 ? void 0 : modifications.borrower) === null || _f === void 0 ? void 0 : _f.firstName, " ", (_g = modifications === null || modifications === void 0 ? void 0 : modifications.borrower) === null || _g === void 0 ? void 0 : _g.lastName, "\n", (_h = modifications === null || modifications === void 0 ? void 0 : modifications.property) === null || _h === void 0 ? void 0 : _h.address1, "\n", (_j = modifications === null || modifications === void 0 ? void 0 : modifications.property) === null || _j === void 0 ? void 0 : _j.city, ", ", (_l = (_k = modifications === null || modifications === void 0 ? void 0 : modifications.property) === null || _k === void 0 ? void 0 : _k.state) === null || _l === void 0 ? void 0 : _l.lookupValue, " ", (_o = (_m = modifications === null || modifications === void 0 ? void 0 : modifications.property) === null || _m === void 0 ? void 0 : _m.zipCode) === null || _o === void 0 ? void 0 : _o.lookupValue)), /*#__PURE__*/React.createElement(View, {
          style: {
            flex: 2,
            flexDirection: "row",
            marginTop: 30
          }
        }, /*#__PURE__*/React.createElement(Text, {
          style: {
            flex: 1,
            fontWeight: "700",
            textAlign: "center",
            fontSize: Platform.OS === "web" ? 18 : 14
          }
        }, translations.PointOfContact, " ", modifications === null || modifications === void 0 ? void 0 : modifications.spoc, "\n", /*#__PURE__*/React.createElement(Text, {
          style: {
            flex: 1,
            fontWeight: "800"
          }
        }, "(866) 629-4570")))), /*#__PURE__*/React.createElement(View, {
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%",
            marginTop: 40,
            marginBottom: 40
          }
        }, /*#__PURE__*/React.createElement(View, {
          i: true,
          style: {
            width: "95%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
          }
        }, /*#__PURE__*/React.createElement(View, {
          id: "modApplication",
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement(PnmacChatAvatar, {
          avatarStyle: {
            borderRadius: 5,
            width: 20,
            height: 20,
            backgroundColor: modifications.statusTypeIsApplication ? "#003087" : modifications.statusTypeIsUnderReview || modifications.statusTypeIsDecision || modifications.statusTypeIsInTrial || modifications.statusTypeIsPendingDocuments || modifications.statusTypeIsCompleted ? "#008000" : "#808080"
          },
          user: {
            name: "1"
          }
        }), /*#__PURE__*/React.createElement(Text, null, modifications.statusTypeIsApplication || modifications.statusTypeIsUnderReview || modifications.statusTypeIsDecision || modifications.statusTypeIsInTrial || modifications.statusTypeIsPendingDocuments || modifications.statusTypeIsCompleted ? !matches.small && translations.ModStatusApp : !matches.small && translations.ModStatusApp)), /*#__PURE__*/React.createElement(Text, {
          alt: "separator",
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }
        }, matches.large ? "──────" : matches.medium ? "──" : "─"), /*#__PURE__*/React.createElement(View, {
          id: "modUnderReview",
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement(PnmacChatAvatar, {
          avatarStyle: {
            borderRadius: 4,
            width: 20,
            height: 20,
            backgroundColor: modifications.statusTypeIsUnderReview ? "#003087" : modifications.statusTypeIsDecision || modifications.statusTypeIsInTrial || modifications.statusTypeIsPendingDocuments || modifications.statusTypeIsCompleted ? "#008000" : "#808080"
          },
          user: {
            name: "2"
          }
        }), /*#__PURE__*/React.createElement(Text, null, modifications.statusTypeIsUnderReview || modifications.statusTypeIsDecision || modifications.statusTypeIsInTrial || modifications.statusTypeIsPendingDocuments || modifications.statusTypeIsCompleted ? !matches.small && translations.ModStatusUnderReview : !matches.small && translations.ModStatusUnderReview)), /*#__PURE__*/React.createElement(Text, {
          alt: "separator",
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }
        }, matches.large ? "──────" : matches.medium ? "──" : "─"), /*#__PURE__*/React.createElement(View, {
          id: "modDecision",
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement(PnmacChatAvatar, {
          avatarStyle: {
            borderRadius: 4,
            width: 20,
            height: 20,
            backgroundColor: modifications.statusTypeIsDecision ? "#003087" : modifications.statusTypeIsInTrial || modifications.statusTypeIsPendingDocuments || modifications.statusTypeIsCompleted ? "#008000" : "#808080"
          },
          user: {
            name: "3"
          }
        }), /*#__PURE__*/React.createElement(Text, null, modifications.statusTypeIsDecision || modifications.statusTypeIsInTrial || modifications.statusTypeIsPendingDocuments || modifications.statusTypeIsCompleted ? !matches.small && translations.ModStatusDecision : !matches.small && translations.ModStatusDecision)), /*#__PURE__*/React.createElement(Text, {
          alt: "separator",
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }
        }, matches.large ? "──────" : matches.medium ? "──" : "─"), /*#__PURE__*/React.createElement(View, {
          id: "modTrial",
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement(PnmacChatAvatar, {
          avatarStyle: {
            borderRadius: 4,
            width: 20,
            height: 20,
            backgroundColor: modifications.statusTypeIsInTrial ? "#003087" : modifications.statusTypeIsPendingDocuments || modifications.statusTypeIsCompleted ? "#008000" : "#808080"
          },
          user: {
            name: "4"
          }
        }), /*#__PURE__*/React.createElement(Text, null, modifications.statusTypeIsInTrial || modifications.statusTypeIsPendingDocuments || modifications.statusTypeIsCompleted ? !matches.small && translations.ModStatusTrial : !matches.small && translations.ModStatusTrial)), /*#__PURE__*/React.createElement(Text, {
          alt: "separator",
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }
        }, matches.large ? "──────" : matches.medium ? "──" : "─"), /*#__PURE__*/React.createElement(View, {
          id: "modFinalDocs",
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement(PnmacChatAvatar, {
          avatarStyle: {
            borderRadius: 4,
            width: 20,
            height: 20,
            backgroundColor: modifications.statusTypeIsPendingDocuments ? "#003087" : modifications.statusTypeIsCompleted ? "#008000" : "#808080"
          },
          user: {
            name: "5"
          }
        }), /*#__PURE__*/React.createElement(Text, null, modifications.statusTypeIsPendingDocuments || modifications.statusTypeIsCompleted ? !matches.small && translations.ModStatusFinalDocs : !matches.small && translations.ModStatusFinalDocs)), /*#__PURE__*/React.createElement(Text, {
          alt: "separator",
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }
        }, matches.large ? "──────" : matches.medium ? "──" : "─"), /*#__PURE__*/React.createElement(View, {
          id: "modComplete",
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement(PnmacChatAvatar, {
          avatarStyle: {
            borderRadius: 4,
            width: 20,
            height: 20,
            backgroundColor: modifications.statusTypeIsCompleted ? "#003087" : "#808080"
          },
          user: {
            name: "6"
          }
        }), /*#__PURE__*/React.createElement(Text, null, " ", modifications.statusTypeIsCompleted ? !matches.small && translations.ModStatusModComplete : !matches.small && translations.ModStatusModComplete)))), /*#__PURE__*/React.createElement(View, {
          style: {
            marginHorizontal: 10
          }
        }, /*#__PURE__*/React.createElement(PnmacSectionListView, {
          idTag1: "modNextSteps",
          ref: _this.expRef,
          data: DATAEXPANDABLE_1,
          collapsableSections: true,
          renderItem: function (_a, collapsed) {
            var _b;
            var item = _a.item;
            if (collapsed.some(function (s) {
              return s == item.header;
            })) {
              if (item.header == translations.NextSteps) {
                return /*#__PURE__*/React.createElement(View, {
                  style: {
                    justifyContent: "center",
                    backgroundColor: "#FFF",
                    borderBottom: "1 solid #e9e9e9"
                  }
                }, /*#__PURE__*/React.createElement(View, {
                  style: {
                    display: "flex",
                    flexDirection: matches.small ? "column" : "row",
                    flex: 1,
                    justifyContent: "space-between",
                    paddingTop: 10,
                    paddingHorizontal: 10
                  }
                }, /*#__PURE__*/React.createElement(View, {
                  style: {
                    flex: 1,
                    marginHorizontal: 10
                  }
                }, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.defaultTextTitle
                }, translations.YourNextSteps), /*#__PURE__*/React.createElement(HtmlToNativeNative, {
                  id: "YourNextStepDescription",
                  value: YourNextStepModStatusDescription_1,
                  navigation: props.navigation
                })), /*#__PURE__*/React.createElement(View, {
                  style: {
                    flex: 1,
                    marginHorizontal: 10
                  }
                }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.defaultTextTitle
                }, translations.OurNextSteps), /*#__PURE__*/React.createElement(HtmlToNativeNative, {
                  id: "OurNextStepDescription",
                  value: OurNextStepModStatusDescription_1,
                  navigation: props.navigation
                })))), alert && /*#__PURE__*/React.createElement(View, {
                  style: {
                    marginHorizontal: 20,
                    marginVertical: 10
                  }
                }, /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(BannerView.Text, null, translations.FileSizeAlert))), (modifications === null || modifications === void 0 ? void 0 : modifications.wallText1) ? /*#__PURE__*/React.createElement(View, {
                  style: {
                    marginHorizontal: 20
                  }
                }, /*#__PURE__*/React.createElement(Text, {
                  style: textStyle.defaultTextDescription
                }, translations === null || translations === void 0 ? void 0 : translations.ForeClosureInformation), /*#__PURE__*/React.createElement(Text, {
                  style: textStyle.defaultTextDescription
                }, modifications === null || modifications === void 0 ? void 0 : modifications.wallText1, " ", modifications === null || modifications === void 0 ? void 0 : modifications.wallText2)) : null, (modifications === null || modifications === void 0 ? void 0 : modifications.isModUploadAllowed) ? /*#__PURE__*/React.createElement(View, {
                  style: {
                    marginHorizontal: 20
                  }
                }, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.defaultTextTitle
                }, (modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeIsApplication) ? translations.ItemsRequired : translations.AddItemsRequired), (pnmacTheme === null || pnmacTheme === void 0 ? void 0 : pnmacTheme.language) == "en" ? /*#__PURE__*/React.createElement(Text, null) : /*#__PURE__*/React.createElement(Text, {
                  style: __assign({
                    marginTop: 15
                  }, textStyle.defaultTextDescription)
                }, translations.SpanishGenereicMsg), ((_b = modifications === null || modifications === void 0 ? void 0 : modifications.pendingConditions) === null || _b === void 0 ? void 0 : _b.length) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BannerView, {
                  style: {
                    marginTop: 20
                  }
                }, /*#__PURE__*/React.createElement(BannerView.Text, null, translations.FileUploadAlert4), /*#__PURE__*/React.createElement(BannerView.Text, null, translations.FileUploadAlert1), /*#__PURE__*/React.createElement(BannerView.Text, null, translations.FileUploadAlert2), /*#__PURE__*/React.createElement(BannerView.Text, null, translations.FileUploadAlert3)), /*#__PURE__*/React.createElement(PendingTable, {
                  modifications: modifications,
                  translations: translations,
                  loading: _this.state.loading,
                  layout: layout,
                  setState: function (state) {
                    _this.setState(state, function () {
                      _this.fileref.current.click();
                    });
                  },
                  navigation: props.navigation
                })) : /*#__PURE__*/React.createElement(Text, null, translations.NoAddItems)) : /*#__PURE__*/React.createElement(View, null));
              }
            } else {
              return null;
            }
          },
          renderSectionHeader: function (_a) {
            var _b, _c, _d, _e;
            var title = _a.section.title;
            var open = ((_c = (_b = _this.expRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
            return /*#__PURE__*/React.createElement(PnmacRowHeader, {
              rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
              rowHeaderContainerStyles: {
                marginBottom: open ? 0 : 10,
                borderBottom: open ? "1 solid #e9e9e9" : "none",
                borderBottomLeftRadius: open ? 0 : 10,
                borderBottomRightRadius: open ? 0 : 10
              },
              onClickExpand: function () {
                var _a;
                return (_a = _this.expRef) === null || _a === void 0 ? void 0 : _a.current.collapseItem(title);
              },
              item: Platform.OS === 'web' ? /*#__PURE__*/React.createElement(PnmacToolTip, {
                swap: true,
                text: title,
                title: "Expand " + title,
                style: textStyle.formTitleSection
              }) : /*#__PURE__*/React.createElement(PnmacParagraph, {
                style: textStyle.formTitleSection
              }, title),
              isExpand: ((_e = (_d = _this.expRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.state.collapsed.indexOf(title)) > -1
            });
          }
        })), !(modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeIsApplication) ? /*#__PURE__*/React.createElement(View, {
          style: {
            margin: 10
          }
        }, /*#__PURE__*/React.createElement(PnmacSectionListView, {
          idTag1: "modCompletedItems",
          ref: _this.expRefList,
          data: DATAEXPANDABLELIST_1,
          collapsableSections: true,
          renderItem: function (_a, collapsed) {
            var item = _a.item;
            if (collapsed.some(function (s) {
              return s == item.header;
            })) {
              if (item.header === translations.CompletedItems) {
                return /*#__PURE__*/React.createElement(View, {
                  id: "completedConditions",
                  style: {
                    backgroundColor: "#FFF",
                    padding: 10,
                    borderBottom: "1 solid #e9e9e9"
                  }
                }, /*#__PURE__*/React.createElement(CompletedTable, __assign({
                  modifications: modifications,
                  translations: translations
                }, props)));
              }
              return /*#__PURE__*/React.createElement(View, null);
            } else {
              return /*#__PURE__*/React.createElement(View, null);
            }
          },
          renderSectionHeader: function (_a) {
            var _b, _c, _d, _e;
            var title = _a.section.title;
            var open = ((_c = (_b = _this.expRefList) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
            return /*#__PURE__*/React.createElement(PnmacRowHeader, {
              rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
              rowHeaderContainerStyles: {
                marginBottom: open ? 0 : 10,
                borderBottom: open ? "1 solid #e9e9e9" : "none",
                borderBottomLeftRadius: open ? 0 : 10,
                borderBottomRightRadius: open ? 0 : 10
              },
              onClickExpand: function () {
                var _a;
                return (_a = _this.expRefList) === null || _a === void 0 ? void 0 : _a.current.collapseItem(title);
              },
              item: Platform.OS === 'web' ? /*#__PURE__*/React.createElement(PnmacToolTip, {
                swap: true,
                text: title,
                title: "Expand " + title,
                style: textStyle.formTitleSection
              }) : /*#__PURE__*/React.createElement(PnmacParagraph, {
                style: textStyle.formTitleSection
              }, title),
              isExpand: ((_e = (_d = _this.expRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.state.collapsed.indexOf(title)) > -1
            });
          }
        })) : /*#__PURE__*/React.createElement(View, null));
      };
      return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
        queries: {
          small: "(max-width: 599px)",
          medium: "(min-width: 600px) and (max-width: 1199px)",
          mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
          large: "(min-width: 1200px)"
        }
      }, function (matches) {
        var _a, _b;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FileUpload, {
          idTag1: "modFileUpload",
          type: "file",
          name: "file",
          onChangeHandler: function (e) {
            _this.uploadForm({
              selectedFile: Platform.OS === "web" ? e.target.files[0] : e,
              conditionId: _this.state.conditionId
            });
          },
          ref: _this.fileref
        }), modifications ? /*#__PURE__*/React.createElement(GetModStatus_1, {
          matches: matches
        }) : /*#__PURE__*/React.createElement(PnmacLinearProgress, null), /*#__PURE__*/React.createElement(TransitionsModal, {
          open: _this.state.open,
          closeModal: function () {
            _this.setState({
              loading: false,
              open: false,
              selectedFile: null,
              isFileNotRecognized: false,
              isValidFileType: true,
              isValidFileSize: true
            });
          },
          translations: translations
        }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
          style: textStyle.defaultTextDescription
        }, translations === null || translations === void 0 ? void 0 : translations.FileUploadModalTitle), _this.state.isFileNotRecognized ? /*#__PURE__*/React.createElement(View, {
          id: "fileUploadSuccess"
        }, /*#__PURE__*/React.createElement(HtmlToNativeNative, {
          id: "fileUploadSuccess",
          value: translations === null || translations === void 0 ? void 0 : translations.FileNotRecognized,
          navigation: props.navigation
        })) : !_this.state.isValidFileType ? /*#__PURE__*/React.createElement(View, {
          id: "fileUploadSuccess"
        }, /*#__PURE__*/React.createElement(HtmlToNativeNative, {
          value: (_a = translations === null || translations === void 0 ? void 0 : translations.FileNameError) === null || _a === void 0 ? void 0 : _a.replace("{0}", _this.state.selectedFile).replace("{1}", ".pdf, .doc, .docx, .png, .jpg, .tif, .txt.pdf, .doc, .docx, .png, .jpg, .tif, .txt")
        })) : !_this.state.isValidFileSize ? /*#__PURE__*/React.createElement(View, {
          id: "fileUploadSuccess"
        }, /*#__PURE__*/React.createElement(HtmlToNativeNative, {
          id: "fileUploadSuccess",
          value: translations === null || translations === void 0 ? void 0 : translations.FileSizeErrorMsg,
          navigation: props.navigation
        })) : /*#__PURE__*/React.createElement(View, {
          id: "fileUploadSuccess"
        }, /*#__PURE__*/React.createElement(HtmlToNativeNative, {
          id: "fileUploadSuccess",
          value: ((_b = translations === null || translations === void 0 ? void 0 : translations.UploadSuccessful) === null || _b === void 0 ? void 0 : _b.replace("{0}", _this.state.selectedFile)) + '<br/>' + (translations === null || translations === void 0 ? void 0 : translations.UploadSuccessfulAndWaitForScanVirus),
          navigation: props.navigation
        })))));
      });
    }
  };
  return Index;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);